import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import Item from './Item';
import Carousel from './Carousel';
import { getPhotos } from '../api/api';

const styles = theme => ({
  root: {
    margin: '30px 0px'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: '50px 0'
  }
});

class Photos extends Component {

  state = {
    open: false,
    selected: 0,
    photos: [],
    loading: true
  }

  async componentDidMount() {
    try {
      const response = await getPhotos();
      const photos = response.items.map(item => ({
        id: item.id,
        image: item.imageUrl,
        caption: item.description
      }));
      this.setState({ photos, loading: false });
    } catch (err) {
      console.error('Failed to load photos:', err);
      this.setState({ loading: false });
    }
  }

  expand = id => {
    const { photos } = this.state;
    const index = photos.findIndex(photo => photo.id === id);
    this.setState({ selected: index, open: true });
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  handleChange = (selected) => {
    this.setState({ selected });
  }

  render() {
    const { open, selected, photos, loading } = this.state;
    const { classes } = this.props;

    if (loading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <Grid
          container
          spacing={2}
          direction="row"
          alignItems="flex-start"
        >
          {photos && photos.map(photo => (
            <Item
              key={photo.id}
              section={photo}
              width={4}
              expendable
              type="photo"
              onExpand={this.expand}
            />
          ))}
        </Grid>
        {photos.length > 0 && (
          <Carousel
            items={photos}
            open={open}
            selected={selected}
            onClose={this.handleClose}
            onChange={this.handleChange}
          />
        )}
      </div>
    )
  }
}

Photos.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Photos);
